export default __webpack_public_path__ + "static/media/28.2b0a7839.jpg";